export default "__VITE_ASSET__BHXsrjCA__"